import { CustomOptionProps } from './index'
import kamBucknerLogoSrc from 'assets/clients/138.kam/Kam-Buckner-Logo-Full-Name-White-3.png';

export const kamOptions: CustomOptionProps = {
  headerIsShown: true,
  hiddenLinks: ['home', 'volunteer'],
  links: [
    { label: 'About Kam', url: 'https://kamformayor.com/about-kam/' },
    {
      label: "Kam's Plan",
      url: 'https://kamformayor.com/4-star-agenda/',
      customClass: 'kamPlan',
      customDropdownLinks: [
        { label: 'Public Safety', url: 'https://kamformayor.com/4-star-agenda/public-safety/' },
        { label: 'Education', url: 'https://kamformayor.com/4-star-agenda/education/' },
        { label: 'Economic Opportunity & Recovery', url: 'https://kamformayor.com/4-star-agenda/economic-opportunity-and-recovery/' },
        { label: 'Fiscal Responsibility', url: 'https://kamformayor.com/4-star-agenda/fiscal-responsibility/' },
      ],
      customDropdownClass: 'kamPlanDropdown'
    }
  ],
  customFooterClass: 'kamFooter',
  customFooterLinks: [
    {
      url: 'https://kamformayor.com/',
      customClass: 'kamBucknerLogo',
      imgSrc: kamBucknerLogoSrc,
    },
    {
      label: "Paid for by Kam for Mayor Chicago",
      customClass: 'paidForByKam',
    },
    {
      url: 'https://facebook.com/KamBucknerCHI/?ref=page_internal',
      customClass: 'kamSocialLogo',
      iconType: 'facebook'
    },
    {
      url: 'https://twitter.com/kambucknerchi',
      customClass: 'kamSocialLogo',
      iconType: 'twitter'
    },
    {
      url: 'https://instagram.com/kambucknerchi/',
      customClass: 'kamSocialLogo',
      iconType: 'instagram'
    },
    {
      url: 'https://linkedin.com/in/kam-buckner-7b29613a/',
      customClass: 'kamSocialLogo',
      iconType: 'linkedin'
    },
    {
      label: "for Press Inquiries email",
      customClass: 'kamForPressText',
    },
    {
      url: 'mailto:press@kamformayor.com',
      label: "press@kamformayor.com",
      customClass: 'kamMailTo',
    },
  ],
  buttons: {
    'Donate': 'https://secure.ngpvan.com/LArXG4hNdEqX8PF71Qj8_g2'
  },
  customText: {
    askQuestion: {
      buttonPrefix: null,
      buttonText: null
    },
    questionListHeader: null,
    answerListHeader: null,
    videoThumbnailHeader: null
  },
  questionsList: {
    showCategoryName: false
  },
  videoThumbnails: {
    preferenceForNames: false
  },
  helpfulHintsEnabled: false
}
